module.exports = __webpack_public_path__ + "img/Wix_Pin_Settings.975623d7.jpg";